import React from 'react';
import styles from '../irlObservations2026.module.css';
import { ModalShell } from '../chrome';

export default function IRL_AI_Review_Review_Response_3({ mode, scope, onRun, onCancel }) {
    return (
        <ModalShell width="narrow">
            <div className={styles.modalHead}>
                <h2 className={styles.modalTitle}>AI Review</h2>
                <button type="button" className={styles.modalClose} onClick={onCancel} aria-label="Close">
                    ×
                </button>
            </div>
            <div className={styles.modalBody}>
                <div className={styles.summaryRow}>
                    <span className={styles.summaryLabel}>Mode</span>
                    <span className={styles.summaryValue}>{mode}</span>
                </div>
                <div className={styles.summaryRow}>
                    <span className={styles.summaryLabel}>Scope</span>
                    <span className={styles.summaryValue}>{scope}</span>
                </div>
                <div className={styles.summaryRow}>
                    <span className={styles.summaryLabel}>Evidence</span>
                    <span className={styles.summaryValue}>Authorised Ready project evidence</span>
                </div>
            </div>
            <div className={styles.modalFoot}>
                <button type="button" className={styles.primaryBtn} onClick={onRun}>
                    Run AI Review
                </button>
                <button type="button" className={styles.mutedBtn} onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </ModalShell>
    );
}
